import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusBadge, Spinner, EmptyState } from "@/components/Common";
import { History, Search, Mail, Paperclip, X } from "lucide-react";

export default function SentHistory() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [detail, setDetail] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await api.get(`/emails/sent?search=${encodeURIComponent(search)}`);
    setEmails(res.data);
    setLoading(false);
  };
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [search]);

  return (
    <div className="p-6 max-w-[1500px]">
      <PageHeader title="Storico Email Inviate & Report" subtitle="Registro completo delle candidature con anteprima messaggio e stato" icon={History} />

      <div className="card p-4 mb-5">
        <div className="relative max-w-md">
          <Search className="w-4 h-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2" />
          <input data-testid="sent-search" value={search} onChange={(e) => setSearch(e.target.value)}
            placeholder="Cerca per hotel o email..." className="input-dark w-full pl-9 pr-3 py-2.5 text-sm" />
        </div>
      </div>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="py-16 flex justify-center"><Spinner className="w-7 h-7" /></div>
        ) : emails.length === 0 ? (
          <EmptyState icon={Mail} title="Nessuna email inviata" hint="Le candidature inviate appariranno qui con oggetto, messaggio e stato di consegna." />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="sent-table">
              <thead>
                <tr className="text-left text-[11px] uppercase tracking-wider text-gray-500 border-b border-white/10">
                  <th className="px-4 py-3">Data</th>
                  <th className="px-4 py-3">Hotel</th>
                  <th className="px-4 py-3">Destinatario</th>
                  <th className="px-4 py-3">Oggetto</th>
                  <th className="px-4 py-3">CV</th>
                  <th className="px-4 py-3">Stato</th>
                </tr>
              </thead>
              <tbody>
                {emails.map((e) => (
                  <tr key={e.id} onClick={() => setDetail(e)} data-testid={`sent-row-${e.id}`}
                    className="border-b border-white/5 hover:bg-white/[0.03] cursor-pointer transition-colors">
                    <td className="px-4 py-3 text-gray-400 whitespace-nowrap">{new Date(e.sent_at).toLocaleString("it-IT")}</td>
                    <td className="px-4 py-3 text-gray-100 font-medium">{e.hotel_name}</td>
                    <td className="px-4 py-3 font-mono text-amber-400/80 text-xs">{e.recipient_email}</td>
                    <td className="px-4 py-3 text-gray-300 max-w-[240px] truncate">{e.subject}</td>
                    <td className="px-4 py-3">{e.cv_filename ? <Paperclip className="w-4 h-4 text-gray-400" /> : <span className="text-gray-600">—</span>}</td>
                    <td className="px-4 py-3"><StatusBadge status={e.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {detail && (
        <div className="fixed inset-0 z-50 flex justify-end" data-testid="sent-detail">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setDetail(null)} />
          <div className="relative w-full max-w-lg h-full bg-[#0E1015] border-l border-white/10 overflow-y-auto fade-up">
            <div className="sticky top-0 bg-[#0E1015]/95 backdrop-blur border-b border-white/10 px-6 py-4 flex items-center justify-between">
              <h3 className="font-head font-semibold">Dettaglio Candidatura</h3>
              <button onClick={() => setDetail(null)} className="text-gray-500 hover:text-gray-200"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div><div className="text-xs text-gray-500">Hotel</div><div className="text-gray-100">{detail.hotel_name}</div></div>
                <div><div className="text-xs text-gray-500">Città</div><div className="text-gray-100">{detail.city}</div></div>
                <div className="col-span-2"><div className="text-xs text-gray-500">Destinatario</div><div className="text-amber-400 font-mono text-xs">{detail.recipient_email}</div></div>
                <div><div className="text-xs text-gray-500">Stato</div><StatusBadge status={detail.status} /></div>
                <div><div className="text-xs text-gray-500">CV allegato</div><div className="text-gray-100 text-xs">{detail.cv_filename || "—"}</div></div>
              </div>
              <div><div className="text-xs text-gray-500 mb-1">Oggetto</div><div className="card p-3 text-sm text-gray-200">{detail.subject}</div></div>
              <div><div className="text-xs text-gray-500 mb-1">Messaggio inviato</div>
                <div className="card p-4 text-sm text-gray-300 whitespace-pre-wrap font-mono leading-relaxed">{detail.message}</div></div>
              {detail.error && <div className="card p-3 text-sm text-red-400 border-red-500/30">{detail.error}</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
